import { SpecialOffers } from "../components/special-offers.vue";
Vue.component("special-offers", SpecialOffers);